/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Modal,
  Button,
  SvgIcon,
  Heading,
  TextArea
} from '../'

export class RequestValidateModal extends React.Component {
  static propTypes = {
    forwardedRef: PropTypes.object,
    requestRun: PropTypes.object,
    requestrunMutate: PropTypes.func,
    callRequestRunMethod: PropTypes.func,
    closeModal: PropTypes.func
  }

  state = {
    showNotes: true
  }

  handleValidateClick = () => {
    const { requestRun, requestrunMutate, callRequestRunMethod } = this.props
    callRequestRunMethod(requestRun.id, requestrunMutate, 'validate')
      .then(this.props.closeModal)
  }

  toggleShowNotes = () => (
    this.setState(prevState => ({ showNotes: !prevState.showNotes }))
  )

  render() {
    const { forwardedRef, closeModal, requestRun } = this.props
    const content = JSON.parse(requestRun.content)

    return (
      <Modal
        ref={forwardedRef}
        body={
          <div className='slds-text-align_center'>
            <Heading>
              Please confirm you have checked capture correctly?
            </Heading>
            {content.notes && content.notes.value &&
              <React.Fragment>
                <Button
                  type='reset'
                  onClick={this.toggleShowNotes}>
                  {this.state.showNotes
                    ? 'Hide request notes'
                    : 'Show request notes'
                  }
                </Button>
                {this.state.showNotes &&
                  <TextArea
                    value={content.notes.value}
                    disabled={true}
                    rows={5}
                    className='slds-m-around_small'
                  />
                }
              </React.Fragment>
            }
            {requestRun.status !== 'ON_HOLD' &&
              <div id='rejectOrValidate' className='slds-m-left_large slds-m-top_medium slds-m-bottom_large'>
                <Button
                  id='requestValidateCancel'
                  onClick={closeModal}
                  minWidth={150}>
                  Cancel
                </Button>
                <Button
                  id='requestInvalidateConfirm'
                  type='brand'
                  onClick={this.handleValidateClick}
                  minWidth={150}>
                  <SvgIcon
                    variant='utility'
                    symbol='check'
                    colour='inverse'
                    size='x-small'
                    buttonIcon={true}
                    className='slds-button__icon_left'
                  />
                  Validate
                </Button>
              </div>
            }
          </div>
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-validate-modal/index.js